// UploadsList.jsx
import React, { useState, useEffect } from 'react';
import config from '../../utils/config'; 
import {useAuth} from '../../utils/AuthContext/AuthContext'; 
import DeleteSVG from '../../assets/Delete';

const UploadsList = () => {
  const [uploads, setUploads] = useState([]);
  const { token } = useAuth();
  // Get the user object from localStorage (or from your AuthContext)
  const userString = localStorage.getItem('user');
  const userObject = userString ? JSON.parse(userString) : null;
  const userId = userObject?.id || userObject?._id;

  useEffect(() => {
    if (userId && token) {
      fetch(`${config.apiBaseUrl}/uploads/${userId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          setUploads(data);
        })
        .catch(error => console.error('Error fetching uploads:', error));
    }
  }, [userId, token]);

  const handleDelete = async (id) => {
    try {
      const response = await fetch(`${config.apiBaseUrl}/upload/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) {
        throw new Error('Delete failed');
      }
      // Remove the deleted upload from the state
      setUploads(uploads.filter(upload => upload._id !== id));
    } catch (err) {
      console.error(err);
    }
  };

  console.log("UploadsList", uploads);

  return (
    <div className="p-4">
      <h2 className="md:text-lg text-sm md:font-semibold md:mb-3 mb-2 mt-8">Uploaded Documents</h2>
      {uploads.length === 0 ? (
        <p>No uploads found.</p>
      ) : (
        <ul className="space-y-2 text-[12px] md:text-[16px]">
          {uploads.map(upload => (
            <li key={upload._id} className="border p-2 rounded">
              <a 
                href={upload.url} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-shi-green hover:underline"
              >
                {upload.originalFilename}
              </a>
              <span className=" text-gray-500 ml-2 text-[12px] md:text-[16px]">
                {new Date(upload.uploadedAt).toLocaleString()}
              </span>
              <button onClick={() => handleDelete(upload._id)} className="text-red-500 ml-2">
                <DeleteSVG width={16} height={16} />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default UploadsList;
